import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { DndDraggable, DndHandle, DndList, DndNoDrag } from '../directives';
import { DndState } from '../services';
import { CommonModule } from '@angular/common';
var DndListModule = (function () {
    function DndListModule() {
    }
DndListModule.ɵfac = function DndListModule_Factory(t) { return new (t || DndListModule)(); };
DndListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DndListModule });
DndListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DndState,
    ], imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DndListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                exports: [
                    DndDraggable, DndHandle, DndList, DndNoDrag,
                ],
                entryComponents: [],
                declarations: [DndDraggable, DndHandle, DndList, DndNoDrag],
                providers: [
                    DndState,
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DndListModule, { declarations: function () { return [DndDraggable, DndHandle, DndList, DndNoDrag]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DndDraggable, DndHandle, DndList, DndNoDrag]; } }); })();
    return DndListModule;
}());
export { DndListModule };

